if (!customElements.get("left-right-slider")) {
  customElements.define(
    "left-right-slider",
    class LeftRightSlider extends HTMLElement {
      constructor() {
        super();
        const left_right_slider = this.querySelector(".left-right__slider");
        if (!left_right_slider) return;

        var upsellSlider = new Flickity(left_right_slider, {
          imagesLoaded: true,
          wrapAround: true,
          prevNextButtons: true,
          pageDots: false,
        });
      }
    },
  );
}
